import type { ServerListParams } from '@crm/shared';
import { createCrudThunks } from '../../store/createCrudThunks';
import { businessApi } from './businessApi';
import type { Business, BusinessCreatePayload, BusinessUpdatePayload } from './businessTypes';

/**
 * Fetch-all: pageSize alto per caricare l'intero set di aziende del gruppo in
 * una request, quando un conteggio/aggregazione client-side dev'essere sull'
 * intero set e non sulla prima pagina (es. i box di riepilogo della Dashboard).
 * Il backend materializza già tutto in memoria (QueryUtil.ALL_POS + subList),
 * quindi non introduce costi DB aggiuntivi rispetto alla paginazione server.
 */
export const FETCH_ALL_PAGE_SIZE = 10000;

const thunks = createCrudThunks<Business, BusinessCreatePayload, BusinessUpdatePayload, ServerListParams>(
  'businesses',
  businessApi,
);

export const businessThunks = thunks;
export const {
  fetchAll: fetchBusinesses,
  fetchOne: fetchBusiness,
  create: createBusiness,
  update: updateBusiness,
  remove: deleteBusiness,
} = thunks;
